<template>
  <div id="user-list">
    <tipos-solicitacao-add-new
      v-model="isAddNewTipoSolicitacaoSidebarActive"
      @refetch-data="getTipoSolicitacao"
    />

    <contadores
      :total="total"
      :ativos="ativos"
      :filtros="filtros"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card>
      <v-card-title> Filtrar </v-card-title>
      <v-row class="px-2 ma-0">
        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model.trim="filtroFila"
            placeholder="Filtar por filas"
            :items="listaFilas"
            item-text="nome"
            item-value="id"
            outlined
            dense
            clearable
            hide-details
            @change="getTipoSolicitacao"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-4"></v-divider>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getTipoSolicitacao"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            color="success"
            class="mb-4 px-4"
            :disabled="!acessoPost"
            @click.stop="isAddNewTipoSolicitacaoSidebarActive = !isAddNewTipoSolicitacaoSidebarActive"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-tipo-solicitacao
          :items="tipoSolicitacaoArr"
          :acesso-disable="acessoDisable"
          @confirmar-inativacao="getTipoSolicitacao"
        />
      </v-col>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiAccount, mdiPlus } from '@mdi/js'
import Contadores from '@/views/tipo-solicitacao/contadores.vue'
import TableTipoSolicitacao from '@/components/tables/TableTipoSolicitacao.vue'
import TiposSolicitacaoAddNew from './TipoSolicitacaoAddNew.vue'
import FilaService from '@/services/modules/FilaService'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    TiposSolicitacaoAddNew,
    TableTipoSolicitacao,
    Contadores,
  },

  setup() {
    const { funcionalidades } = storeToRefs(useAuthStore())
    const isAddNewTipoSolicitacaoSidebarActive = ref(false)

    const tipoSolicitacaoArr = ref([])
    const ativos = ref([])
    const total = ref([])
    const loading = ref(true)
    const search = ref('')
    const filtros = ref('')
    const filtroFila = ref(null)
    const listaFilas = ref([])
    const idPost = 1051
    const idDisable = 1053
    const acessoPost = ref(true)
    const acessoDisable = ref(true)

    const opcoes = [
      { title: 'Inativos', value: 'false' },
      { title: 'Ativos', value: 'true' },
      { title: 'Todos', value: '' },
    ]

    function permissoes() {
      if (!funcionalidades.value.includes(idPost)) {
        acessoPost.value = false
      }
      if (!funcionalidades.value.includes(idDisable)) {
        acessoDisable.value = false
      }
    }

    async function getFilas() {
      try {
        listaFilas.value = await FilaService.getFilasAtivas(100)
      } catch {
        //
      }
    }

    async function getTipoSolicitacao() {
      await TipoSolicitacaoService
        .get(filtroFila.value)
        .then(response => {
          tipoSolicitacaoArr.value = response.data.data
          total.value = tipoSolicitacaoArr.value
          ativos.value = tipoSolicitacaoArr.value.filter(s => s.ativo === true)

          if (search.value) {
            tipoSolicitacaoArr.value = tipoSolicitacaoArr.value.filter(
              ts => ts.nome.toLowerCase().includes(search.value.toLowerCase())
                || ts.descricao.toLowerCase().includes(search.value.toLowerCase()),
            )
          }
          if (filtros.value) {
            tipoSolicitacaoArr.value = tipoSolicitacaoArr.value.filter(
              tipoSolicitacao => tipoSolicitacao.ativo.toString() === filtros.value,
            )
          }

          tipoSolicitacaoArr.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))

          setTimeout(() => {
            loading.value = false
          }, 1000)
        })
        .catch(() => {
          loading.value = false
        })
    }

    function atualizarFiltro(item) {
      filtros.value = item
      getTipoSolicitacao()
    }

    onMounted(() => {
      getTipoSolicitacao()
      // permissoes()
      getFilas()
    })

    return {
      isAddNewTipoSolicitacaoSidebarActive,
      tipoSolicitacaoArr,
      total,
      loading,
      search,
      filtros,
      filtroFila,
      listaFilas,
      ativos,
      acessoPost,
      acessoDisable,
      opcoes,
      getTipoSolicitacao,
      atualizarFiltro,
      icons: {
        mdiPlus,
        mdiAccount,
      },
    }
  },
}
</script>
